// extracted by mini-css-extract-plugin
module.exports = {"cards":"CommitmentCard_cards__z5iZ3","card":"CommitmentCard_card__s8c7l","title":"CommitmentCard_title__JO6oh","icon":"CommitmentCard_icon__fMprl"};